import React, { ReactNode, useCallback, useContext } from 'react';
import get from 'lodash/get';
import set from 'lodash/set';

import styled from 'styled-components';

import Checkbox from 'src/presentation/components/forms/Checkbox';
import FormContext from 'src/presentation/contexts/FormContext';
import { Row } from './controls/Layout';

type BoolProps = {
  attr: string;
  'data-aid'?: string;
  description?: string | ReactNode;
  disabled?: boolean;
  prompt: string;
};

export default function BoolControl({ attr, 'data-aid': dataAid, description, disabled, prompt }: BoolProps) {
  const { workingState, onBlur } = useContext(FormContext);
  const val = get(workingState, attr);

  const changeHandler = useCallback(
    checked => {
      const newState = set({}, attr, checked);
      onBlur && onBlur({ currentState: newState });
    },
    [attr, onBlur]
  );

  return (
    <Row>
      <StyledCheckbox
        attr={attr}
        className="checkbox"
        data-aid={dataAid}
        description={description}
        disabled={disabled}
        label={prompt}
        onChange={changeHandler}
        value={val}
        wrapperClassName="bool-element"
      />
    </Row>
  );
}

const StyledCheckbox = styled(Checkbox)`
  align-items: flex-start !important;
  font-weight: 700;
`;
